import { ReactSortable } from "react-sortablejs";
import returnIcon from "../../../../assets/img/modals/return.svg";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../../loader";
import { apiUrl } from "../../../../utils/url";
import FormFieldError from "../../../errors/formFieldError";
import tickIconPrimary from "../../../../assets/img/white-tick-icon.svg";
import ErrorMessage from "../../../errors/errorMessage";
import CroppieModal from "../../../croppie-modal";
import { toast } from "react-toastify";
import removeicon from "../../../../assets/img/products/removeicon.svg";
import SelectedThemeInput from "../../../custom-theme/commons/select-theme-input";
import SelectedCustomTheme from "../../../custom-theme/commons/select-custom-theme";
import lightmodeicon from "../../../../assets/img/products/lightmodeicon.svg";

const DetailsPage = ({ data, handleSubmit , error, setError }) => {
    const fileupload = useRef(null);
    const [title, setTitle] = useState(data?.name);
    // const [company_name, setCompanyName] = useState(data?.company_name);
    const [short_description, setShort_Description] = useState(data?.short_description);
    const [price_type, setPriceType] = useState(data?.price_type);
    const [domain_type, setDomainType] = useState(data?.domain_type);
    const [price, setPrice] = useState(data?.price);
    const [min_price, setMin_Price] = useState(data?.price_type !== "suggested_price" ? 0 : data?.price );
    const [suggested_price, setSugested_Price] = useState(data?.suggested_price);
    const [currency, setCurrency] = useState(data?.currency);
    const [product_slug, setProductSlug] = useState(data?.slug);
    const [cover_image, setCover_Image] = useState(data?.cover_images);
    const [croppie_image, setcroppie_image] = useState({ url: "", id: null });
    const [croppie, setCroppie] = useState(null);
    const [deleted_cover_image, setDeleted_cover_image] = useState([])
    const [logo, setLogo] = useState(data?.logo)
    const [product_theme, setProductTheme] = useState(data?.product_theme);
    const [accent_theme, setAccent_Theme] = useState(data?.accent_theme);
    const dispatch = useDispatch();
    const { slug } = useSelector(state => state?.slugReducer);
    const [buy_button_text, set_buy_button_text] = useState(data?.buy_button_text ?? '');
    const [button_url, set_button_url] = useState(data?.button_url);
    const brandings = useSelector(state => state?.allBrandingReducer);
    const defaultBranding = brandings.find(branding => branding.id === data?.branding_id);
    const [selectedBrand, setSelectedBrand] = useState({id:defaultBranding?.id,logo:defaultBranding?.logo,name:defaultBranding?.brand_name});
    const [branding_id, setBrandingId] = useState(data?.branding_id);
    const handlePriceTypeChange = (a) => {
        setPriceType(a.target.value)
        if (a.target.value == 'free') {
            setPrice(0);
            setMin_Price(0);
            setSugested_Price(0);
        } else if (a.target.value == 'single_payment') {
            setMin_Price(0);
            setSugested_Price(0);
        }
    };
    const handlePriceChange = (e) => {
        const sanitizedValue = e.target.value.replace(/[^0-9.]/g, '');

        const singleDecimalValue = sanitizedValue.replace(/(\..*?)\..*/g, '$1');
        if (e.target.name === "price") {
            setPrice(singleDecimalValue);
            setMin_Price(0);
            setSugested_Price(0);
        }
        else if (e.target.name === "min_price") {
            setMin_Price(singleDecimalValue);
            setPrice(0);
        }
        else if (e.target.name === "suggested_price") {
            setSugested_Price(singleDecimalValue);
            setPrice(0);
        }
    };

    const handleTitleChange = (e) => {
        setTitle(e.target.value)
        let slug = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-');
        slug = slug.replaceAll(' ', '-');
        setProductSlug(slug)
    }
    const onfilechange = (e) => {
        const fileList = e.target.files[0];
        var reader = new FileReader();

        reader.onload = function (event) {
            setLogo(event.target.result);
        };
        reader.readAsDataURL(fileList);
    }
    // const handleopenmodal = (e) => {
    //     setcroppie_image({ url: "", id: null, name: null, type: null });
    //     generate_image_preview(e.target);
    //     hideLoader();
    // };
    // const [showCroppieModal, setshowCroppieModal] = useState(null);

    // function generate_image_preview(input) {
    //     showLoader();
    //     if (input.files && input.files[0]) {
    //         let reader = new FileReader();
    //         if (input.files[0].size >= 5242880) {
    //         $("#image_file_input").val("");
    //         let notification_container = $(".notification-container");
    //         toast.error("File Size Should not exceed 5MBs");
    //         // showModal();
    //         return;
    //         }
    //         let val = input.files[0].name;
    //         let valid_extensions = ["png", "jpg", "jpeg"];
    //         let extension =
    //         val.substring(val.lastIndexOf(".") + 1, val.length) || val;
    //         if (!valid_extensions.includes(extension)) {
    //         $("#image_file_input").val("");
    //         let notification_container = $(".notification-container");
    //         toast.error("Invalid Image File. Should be png, jpg or jpeg");
    //         // showModal();
    //         return;
    //         }
    //         reader.onload = (event) => {
    //         setcroppie_image({
    //             ...croppie_image,
    //             url: event.target.result,
    //         });
    //         console.log(setcroppie_image);
    //         console.log("setcroppie_image", croppie_image);
    //         setshowCroppieModal(true);
    //         setTimeout(() => {
    //             const el = document.getElementById("image_demo2");
    //             try {
    //             console.log("el", el);
    //             if (el) {
    //                 var croppieInstance = new Croppie(el, {
    //                 enableExif: true,
    //                 viewport: {
    //                     width: 850,
    //                     height: 470,
    //                     type: "square",
    //                 },
    //                 boundary: {
    //                     width: 870,
    //                     height: 570,
    //                 },
    //                 });
    //                 croppieInstance
    //                 .bind({
    //                     url: event.target.result,
    //                 })
    //                 .then(function () {
    //                     console.log("jQuery bind complete");
    //                     setTimeout(() => { }, 300);
    //                 })
    //                 .catch(() => {
    //                     croppieClose();
    //                 });
    //                 setCroppie(croppieInstance);
    //             }
    //             } catch { }
    //         }, 500);
    //         };
    //         reader.readAsDataURL(input.files[0]);
    //     }
    // }
    // const croppedImage = () => {
    //     if (croppie !== null) {
    //       croppie
    //         .result({
    //           type: "canvas",
    //           size: "original",
    //           format: "png",
    //           quality: 1,
    //         })
    //         .then((response) => {
    //           const tempObj = { image_url: response };
    //           croppie
    //             .result({
    //               size: "viewport",
    //               format: "png",
    //               quality: 1,
    //               type: "blob",
    //             })
    //             .then((res) => {
    //               setLogo(response)
    //               croppieClose()
    //             });
    //         });
    //     }
    // };
    // const handleHideModal = () => {
    //     setshowCroppieModal(false);
    //     setCroppie(null);
    //     setcroppie_image({ url: "", id: null });
    // };
    // const croppieClose = () => {
    //     showLoader();
    //     setshowCroppieModal(false);
    //     setCroppie(null);
    //     setTimeout(() => {
    //         hideLoader();
    //     }, 400);
    // };
    function Removecardfun({ i, id }) {
        setDeleted_cover_image([...deleted_cover_image, id])
        if (!id) {
            setDeleted_cover_image([...deleted_cover_image, 'old_cover_image'])
        }
        const covimg = [...cover_image]
        covimg.splice(i, 1)
        setCover_Image(covimg)
    }
    const updateDetials = (e) => {
        const obj = {
            title,
            short_description,
            product_slug,
            product_theme,
            // accent_theme,
            // price_type,
            domain_type,
            // logo,
            buy_button_text,
            button_url,
            branding_id
            // price,
            // min_price,
            // suggested_price,
            // currency,
            // cover_image,
            // deleted_cover_image,
        };
        handleSubmit(e,obj,'details');
    }
    useEffect(()=>{
        if (data?.cover_image) {
            setCover_Image(prevCoverImages => [...prevCoverImages, {images:data?.cover_image}]);
        }
    },[data?.cover_image])
    const themeChange = () => { 
        $('.color-picker-modal').removeClass("d-none");  
        $('.color-picker-main').removeClass("d-none");   
        $('.color-picker-modal').addClass("d-flex");
        $('.color-picker-main').addClass("d-flex");
    };
    const colorChange = (color) => {
        setAccent_Theme(color)
    }
    const handleSelectValue = (val) => {
        setSelectedBrand({id:val?.id,logo:val?.logo,name:val?.brand_name})
        setBrandingId(val?.id)
    };
    return (
        <div class="tab-pane fade customize-page-main active show p20-u" id="customizePageSocials" role="tabpanel" aria-labelledby="social-tab">
            <h4 class="productHead1">Campaign Details</h4>
                <form id="newProductModal" className="ProductBody" name="product_type" method="post" role="form">
                    <div className="notification-container"></div>
                    <div>
                        <ErrorMessage error={error} />
                            {/* <div class="form-group mt-20px">
                                <div className="d-flex align-items-center py-1">
                                    <label class="text-gray font-14-u">Company Logo</label>
                                </div>
                                <div class="mb-3 d-flex ps-0 zaap-border-rounded py-2" style={{ borderColor: '#E8E9EA', gap: "7px" }}>
                                    {logo ? <img className="dropzone-wrapper dropzone-wrapper5 fav-uplod" src={logo} /> : null}
                                    <div className="d-flex justify-content-end uplod-btn-u">
                                        <input id="file-upload" type="file" ref={fileupload} className="d-none" accept=".png,.jpg,.jpeg" name="logo"  onChange={onfilechange} />
                                        <button type="button" onClick={() => fileupload.current.click()} class="btn btn-semi-rounded d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333"/>
                                            </svg>
                                            <span class="upload-text">Upload New</span>
                                        </button>
                                    </div>
                                </div>
                            </div> */}
                        <div className="form-group mt-20px">
                            <label className="productlabels">
                                Campaign Title
                            </label>
                            <input
                                value={title}
                                onChange={(e) => handleTitleChange(e)}
                                type="text"
                                className="zaapGlobal-input"
                                name="title"
                                placeholder="eg: May SaaS Leads"
                            />
                            <FormFieldError error={error?.title} />
                        </div>
                        <div className="form-group mt-20px">
                            <label className="productlabels">
                                Pick Brand
                                <small className="text-red">*</small>
                            </label>
                            <div class="table-action-dropdown p-1 d-flex justify-content-between align-items-center gap-2 cursor-pointer zaapGlobal-input dropdown-toggle noselect dropdown-subscribers" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                                <span className="d-flex align-items-center gap-2">
                                    <span>
                                        <img className="brand-logo" width={"25px"} height={"25px"} src={selectedBrand?.logo} alt="" />
                                    </span>
                                    <span>
                                        {selectedBrand?.name}
                                    </span>
                                </span>
                            </div>
                            <ul class="dropdown-menu brand-dropdown-menu" aria-labelledby="table-action-dropdown">
                                {brandings?.length > 0 && (
                                    brandings.map((val, idx) => (
                                        <li key={idx} onClick={() => handleSelectValue(val)}>
                                            <a class={`dropdown-item cursor-pointer border-radius-9`} >
                                                <span><img className="brand-logo" width={"25px"} height={"25px"} src={val?.logo} alt="" /></span>
                                                <span>{val?.brand_name} </span>
                                            </a>
                                        </li>
                                    ))
                                )}
                            </ul>
                    </div>
                        <div className="form-group mt-20px">
                            <label className="productlabels">
                                Product/Service Descripton
                            </label>
                            <input value={short_description} onChange={(a) => setShort_Description(a.target.value)}
                                type="text"
                                className="zaapGlobal-input"
                                name="short_description"
                                placeholder="Got my new awesome course!"
                            />
                        </div>

                        <div className="form-group mt-20px">
                            <label className="productlabels">
                                Domains
                            </label>
                            <div className="zaapGlobal-input d-flex align-items-center gap-2">
                                <div>
                                    yourdomain.com/
                                </div>
                                <div className="header-dropdown domain_type_dropdown dropdown-toggle noselect " id="header-share-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    {domain_type == "company_name" ? 'Company Name' : 'Lead First Name'}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.188289 0.683058C0.43934 0.438981 0.846375 0.438981 1.09743 0.683058L4.5 3.99112L7.90257 0.683058C8.15363 0.438981 8.56066 0.438981 8.81171 0.683058C9.06276 0.927136 9.06276 1.32286 8.81171 1.56694L4.95457 5.31694C4.70352 5.56102 4.29648 5.56102 4.04543 5.31694L0.188289 1.56694C-0.0627628 1.32286 -0.0627628 0.927136 0.188289 0.683058Z" fill="#012125"/>
                                    </svg>
                                </div>
                                    <ul className="dropdown-menu domain-type-dropdown-main" style={{borderRadius:"15px"}} aria-labelledby="header-share-dropdown">
                                        <li>
                                            <div onClick={()=>setDomainType(domain_type !== "company_name" ? "company_name":'lead_first_name')} className="share-dropdown-text share-dropdown-item domain-dropdown-item d-flex justify-content-evenly align-items-center" >
                                                {domain_type !== "company_name" ? 'Company Name' : 'Lead First Name'}
                                            </div>
                                        </li>
                                    </ul>
                                {/* <input className="input-style2" maxLength={20} value={product_slug?.toLowerCase()} onChange={(a) => setProductSlug(a.target.value)} autoComplete="off" type="text" name="product_slug"/> */}
                            </div>
                        </div>

                        <div className="form-group mt-20px">
                            <div className="col-6 pl-0 d-flex align-items-center" id="header-theme">
                                <span className="zaap-normal-text">Page Theme</span>
                            </div>
                            <div className="up-in-toggle mt-0 bg-f7f7f8  product-style theme-toggle">
                                <input
                                    onChange={(a) =>
                                        setProductTheme(a.target.value)
                                    }
                                    type="radio"
                                    id="file_type_switch_left"
                                    name="product_theme"
                                    value="light"
                                    className="light-inp"
                                    checked={product_theme == "light" ? true : false}
                                />
                                <label
                                    htmlFor="file_type_switch_left"
                                    className="d-flex align-items-center justify-content-center"
                                >
                                    {" "}
                                    <img
                                        src={lightmodeicon}
                                        style={{ marginRight: 5 }}
                                        width="13px"
                                    />
                                    <span class="font-weight-500 dark-style">Light</span>
                                </label>
                                <input
                                    onChange={(a) =>
                                        setProductTheme(a.target.value)
                                    }
                                    type="radio"
                                    id="file_type_switch_right"
                                    name="product_theme"
                                    value="darkmode"
                                    checked={product_theme == "darkmode" ? true : false}
                                />
                                <label
                                    htmlFor="file_type_switch_right"
                                    className="d-flex align-items-center justify-content-center"
                                >
                                    {/* <img style={{ marginRight: 5 }} src={darkmodeicon} width="25px" /> */}
                                    <svg width="13" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.5 12L6.28446 13.5689C6.54995 14.0999 6.68269 14.3654 6.86003 14.5954C7.01739 14.7996 7.20041 14.9826 7.40455 15.14C7.63462 15.3173 7.9001 15.4501 8.43108 15.7155L10 16.5L8.43108 17.2845C7.9001 17.5499 7.63462 17.6827 7.40455 17.86C7.20041 18.0174 7.01739 18.2004 6.86003 18.4046C6.68269 18.6346 6.54995 18.9001 6.28446 19.4311L5.5 21L4.71554 19.4311C4.45005 18.9001 4.31731 18.6346 4.13997 18.4046C3.98261 18.2004 3.79959 18.0174 3.59545 17.86C3.36538 17.6827 3.0999 17.5499 2.56892 17.2845L1 16.5L2.56892 15.7155C3.0999 15.4501 3.36538 15.3173 3.59545 15.14C3.79959 14.9826 3.98261 14.7996 4.13997 14.5954C4.31731 14.3654 4.45005 14.0999 4.71554 13.5689L5.5 12Z" stroke="#6B6B6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M14 1L15.1786 4.06442C15.4606 4.79765 15.6016 5.16426 15.8209 5.47264C16.0153 5.74595 16.254 5.98475 16.5274 6.17909C16.8357 6.39836 17.2024 6.53937 17.9356 6.82138L21 8L17.9356 9.17862C17.2024 9.46063 16.8357 9.60164 16.5274 9.82091C16.254 10.0153 16.0153 10.254 15.8209 10.5274C15.6016 10.8357 15.4606 11.2024 15.1786 11.9356L14 15L12.8214 11.9356C12.5394 11.2024 12.3984 10.8357 12.1791 10.5274C11.9847 10.254 11.746 10.0153 11.4726 9.82091C11.1643 9.60164 10.7976 9.46063 10.0644 9.17862L7 8L10.0644 6.82138C10.7976 6.53937 11.1643 6.39836 11.4726 6.17909C11.746 5.98475 11.9847 5.74595 12.1791 5.47264C12.3984 5.16426 12.5394 4.79765 12.8214 4.06442L14 1Z" stroke="#6B6B6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                    <span className="dark-style" style={{ marginLeft: 5 }}>Dark</span>

                                </label>
                            </div>
                        </div>
                        <div className="form-group mt-20px">
                            <label className="productlabels">
                                CTA Button
                            </label>
                            <input value={buy_button_text} onChange={(a) => set_buy_button_text(a.target.value)}
                                type="text"
                                className="zaapGlobal-input"
                                name="buy_button_text"
                                placeholder="Button Text"
                            />
                            <input value={button_url} onChange={(a) => set_button_url(a.target.value)}
                                type="url"
                                className="zaapGlobal-input mt-2"
                                name="button_url"
                                placeholder="Button URL"
                            />
                        </div>
                    </div>

                    <div class="text-center mt-4 d-flex submit-buttons-fixed">
                        <button type="button" onClick={(e)=>updateDetials(e)} class="btn btn-primary btn-semi-rounded d-flex align-items-center justify-content-center">
                            <b class="me-2 productlabel2">Save Changes</b>
                            <small class="badge bg-primary-dark text-dark px-2 py-1 d-flex align-items-center justify-content-center">
                                <img src={returnIcon} alt="" />
                            </small>
                        </button>
                    </div>
                </form>
                {/* <CroppieModal show={showCroppieModal} handleHide={handleHideModal} croppieClose={croppieClose} croppedImage={croppedImage} modalWidth={500} productCroppie={"productCroppie"} /> */}
        </div >
    )
}
export default DetailsPage